module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row head-banner"
  }, [_c('div', {
    staticClass: "row banner-row",
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.set_sellpoint_banner_image + ')'
    })
  }, [_c('div', {
    staticStyle: {
      "margin-left": "40%",
      "margin-top": "12%",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "card-avatar-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.sellpoint.business_brand_image
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto",
      "color": "#ffffff"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_category))])])]), _vm._v(" "), (_vm.sellpoint.business_categories && (_vm.sellpoint.business_categories.length > 1)) ? _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.sellpoint.business_categories), function(category) {
    return (category.business_category_has_product == 1) ? _c('li', [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": category.business_category_image
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(category.business_category_name))])]) : _vm._e()
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-top-header sticky-tab",
    attrs: {
      "id": "pageStickyHeader"
    }
  }, [_c('div', {
    staticClass: "tab-slide-md"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "welcomeView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('welcomeView')
      }
    }
  }, [_vm._v("Welcome")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "aboutView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('aboutView')
      }
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "categoriesView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('categoriesView')
      }
    }
  }, [_vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "productsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('productsView')
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "reviewsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('reviewsView')
      }
    }
  }, [_vm._v("Reviews")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "newsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('newsView')
      }
    }
  }, [_vm._v("News")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "eventsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('eventsView')
      }
    }
  }, [_vm._v("Events")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "dealsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('dealsView')
      }
    }
  }, [_vm._v("Deals")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "contactView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('contactView')
      }
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "chatView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('chatView')
      }
    }
  }, [_vm._v("Chat")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-after-stick",
    staticStyle: {
      "padding": "0 0.5em",
      "margin-bottom": "5em"
    }
  }, [(_vm.menu_view.welcomeView) ? _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-6 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()]), _vm._v(" "), _vm._m(0, true)])])])
  })) : _vm._e(), _vm._v(" "), (_vm.menu_view.aboutView) ? _c('div', [_vm._v("\r\n          About"), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.followSellpoint
    }
  }, [_vm._v("Follow " + _vm._s(_vm.sellpoint.business_username))])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.categoriesView) ? _c('div', [_vm._v("\r\n          Categories\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.productsView) ? _c('div', [_vm._v("\r\n          Products\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.reviewsView) ? _c('div', [_vm._v("\r\n          Reviews\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newsView) ? _c('div', {
    staticStyle: {
      "padding": "0 2em"
    }
  }, [_vm._v("\r\n          News\r\n          "), _vm._l((_vm.business_posts), function(post) {
    return _c('div', {
      staticClass: "card card-strip"
    }, [_c('div', [_c('div', {
      staticClass: "card"
    }, [(post.post_media && (post.post_media.length > 0)) ? _c('div', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": post.post_media[0].post_media
      }
    })]) : _c('div', [(post.post_products[0]) ? _c('div', [(post.post_products[0].product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": post.post_products[0].product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('h5', [_vm._v(_vm._s(post.post_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_post))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.followPost(post)
        }
      }
    }, [_vm._v("Follow Event")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (post.post_comment),
        expression: "post.post_comment"
      }],
      domProps: {
        "value": (post.post_comment)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          post.post_comment = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.postComment(post)
        }
      }
    }, [_vm._v("Post Comment")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.menu_view.eventsView) ? _c('div', [_vm._v("\r\n          Events\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.dealsView) ? _c('div', [_vm._v("\r\n          Deals\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.contactView) ? _c('div', [_vm._v("\r\n          Contact\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.chatView) ? _c('div', [_c('li', {
    staticClass: "header-left"
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v("\r\n          Hi Chat\r\n          "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('showProductGrid')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th"
  })]), _vm._v(" "), (_vm.menu_tab_view.showProductGrid) ? _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-6 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.postChatObject(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })) : _c('div', [(_vm.edit_mode) ? _c('div', {
    staticClass: "container"
  }, [((Object.keys(_vm.chat_log).length != 0)) ? _c('div', [_vm._l((_vm.chat_log), function(chat) {
    return _c('div', {
      staticClass: "row"
    }, [(_vm.sellpoint.business_id == chat.chat_from) ? _c('div', {
      staticStyle: {
        "margin": "0.6em 0",
        "border-radius": "1em",
        "border": "#e6e3e3 solid",
        "padding": "0.5em",
        "width": "85%",
        "text-align": "left",
        "float": "right"
      }
    }, [(chat.chat_message_type == 8) ? _c('div', [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + chat.chat_message_object_product_url_name
      }
    }, [_c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "border-radius": "4px"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [(chat.chat_message_object_product_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": chat.chat_message_object_product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(chat.chat_message_object_product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(chat.chat_message_object_product_price))])])])])])]) : _c('div', [_vm._v("\r\n                        " + _vm._s(chat.chat_message) + "\r\n                      ")])]) : _c('div', {
      staticStyle: {
        "margin": "0.6em 0",
        "border-radius": "1em",
        "border": "#e6e3e3 solid",
        "padding": "0.8em",
        "width": "85%",
        "text-align": "left",
        "float": "left"
      }
    }, [(chat.chat_message_type == 8) ? _c('div', [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + chat.chat_message_object_product_url_name
      }
    }, [_c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "border-radius": "4px"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [(chat.chat_message_object_product_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": chat.chat_message_object_product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(chat.chat_message_object_product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(chat.chat_message_object_product_price))])])])])])]) : _c('div', [_vm._v("\r\n                        " + _vm._s(chat.chat_message) + "\r\n                      ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "bottom": "5em",
      "position": "fixed"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.postChat
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])])], 2) : _vm._l((_vm.chat_logs), function(chatlog) {
    return _c('div', {
      staticClass: "row"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setChatLog(chatlog.chatlog_from_to, chatlog.chats)
        }
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "border": "gray solid",
        "padding": "0.5em",
        "width": "85%",
        "text-align": "left"
      }
    }, [_vm._v("\r\n                    " + _vm._s(chatlog.chatlog_from_to) + "\r\n                  ")])])])
  })], 2) : _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.chat_log), function(chat) {
    return _c('div', {
      staticClass: "row"
    }, [(_vm.sellpoint.business_id == chat.chat_from) ? _c('div', {
      staticStyle: {
        "margin": "0.6em 0",
        "border-radius": "1em",
        "border": "#e6e3e3 solid",
        "padding": "0.5em",
        "width": "85%",
        "text-align": "left",
        "float": "right"
      }
    }, [(chat.chat_message_type == 8) ? _c('div', [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + chat.chat_message_object_product_url_name
      }
    }, [_c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "border-radius": "4px"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [(chat.chat_message_object_product_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": chat.chat_message_object_product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(chat.chat_message_object_product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(chat.chat_message_object_product_price))])])])])])]) : _c('div', [_vm._v("\r\n                      " + _vm._s(chat.chat_message) + "\r\n                    ")])]) : _c('div', {
      staticStyle: {
        "margin": "0.6em 0",
        "border-radius": "1em",
        "border": "#e6e3e3 solid",
        "padding": "0.8em",
        "width": "85%",
        "text-align": "left",
        "float": "left"
      }
    }, [(chat.chat_message_type == 8) ? _c('div', [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + chat.chat_message_object_product_url_name
      }
    }, [_c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "border-radius": "4px"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [(chat.chat_message_object_product_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": chat.chat_message_object_product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(chat.chat_message_object_product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(chat.chat_message_object_product_price))])])])])])]) : _c('div', [_vm._v("\r\n                      " + _vm._s(chat.chat_message) + "\r\n                    ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "bottom": "5em",
      "position": "fixed"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.postChat
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('chatView')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6892836b"}!./src/pages/Sellpoint/Sellpoint/template.html
// module id = 403
// module chunks = 0